import { ia } from 'lib/helpers/utility';

import Popover from 'components/shared/Popovers/Popover/Popover';

import selectedHeaders from '../lib/selectedHeader';

import DataMapOptions from './DataMapOptions';
import ImportSelectItem from './ImportSelectItem';

const ReviewAndEdit = ({
  headers,
  headerValue,
  setHeaderValue,
  file,
  show,
  setShow,
  patientDetailsFormat,
  setPatientDetailsFormat,
  columnHeaderOptions,
  dobFormatRef,
  addressFormatRef,
  nameFormatRef,
  setColumnHeaderOptions,
  policyStartDateFormatRef,
  policyEndDateFormatRef,
  providerNameFormatRef,
  transactionAmountFormatRef,
  transactionAmountSelfFormatRef
}) => {
  const handleHeaderSelect = async (e, index) => {
    await selectedHeaders({
      e,
      index,
      headerValue,
      show,
      setHeaderValue,
      setColumnHeaderOptions,
      setPatientDetailsFormat,
      setShow,
      dobFormatRef,
      nameFormatRef,
      policyStartDateFormatRef,
      policyEndDateFormatRef,
      providerNameFormatRef,
      transactionAmountFormatRef,
      transactionAmountSelfFormatRef
    });
  };
  const refs = {
    dobFormatRef,
    addressFormatRef,
    nameFormatRef,
    policyStartDateFormatRef,
    policyEndDateFormatRef,
    providerNameFormatRef,
    transactionAmountFormatRef,
    transactionAmountSelfFormatRef
  };

  const onChangeHandler = (event, key, selectRef, index) => {
    setPatientDetailsFormat((prevState) => ({
      ...prevState,
      [key]: event
    }));
    selectRef.current = event;
    setTimeout(() => handleHeaderSelect(headerValue[index], index), 100);
  };
  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="text-neutral-500">Review and map your inputs.</div>
        <Popover
          isFixed
          position="bottom"
          iconRight="chevron-down-2-linear"
          icon=""
          text="Auto-Actions"
          buttonClassName="border border-solid gap-2 border-neutral-100"
          activeClassNames="bg-primary-500">
          <div className="p-3">
            <div className="mb-2.5 text-neutral-600">Quick Actions</div>
            <div>
              <DataMapOptions setShow={setShow} show={show} />
            </div>
          </div>
        </Popover>
      </div>
      <div className="flex gap-4">
        <table className="w-full border-separate border-spacing-x-4 border-spacing-y-4">
          <thead className="text-left font-medium text-primary-900">
            <tr className="align-top">
              <td className="align-top">Column</td>
              <td className="align-top">Mapping Input</td>
              <td className="align-top">Example #1</td>
              <td className="align-top">Example #2</td>
              <td className="align-top">Example #3</td>
            </tr>
          </thead>

          <tbody>
            {ia(headers) &&
              headers.map((header, index) => (
                <tr key={index} className="align-top">
                  <td className="max-w-[180px] align-middle">{header}</td>

                  <td className="align-top">
                    <div className="h-full w-full">
                      <ImportSelectItem
                        headerValue={headerValue[index]}
                        patientDetailsFormat={patientDetailsFormat}
                        columnHeaderOptions={columnHeaderOptions}
                        onChangeHandler={onChangeHandler}
                        handleHeaderSelect={handleHeaderSelect}
                        index={index}
                        refs={refs}
                      />
                    </div>
                  </td>

                  <td className="max-w-[180px] align-top">
                    <div className="h-[40px] w-full truncate break-words rounded-lg border border-solid border-neutral-200 bg-neutral-50 px-3 py-2">
                      {file.sampleEntries[0][index] ?? (
                        <span className="text-warning-900">N/A</span>
                      )}
                    </div>
                  </td>

                  <td className="max-w-[180px] align-top">
                    <div className="h-[40px] w-full truncate break-words rounded-lg border border-solid border-neutral-200 bg-neutral-50 px-3 py-2">
                      {file.sampleEntries[1][index] ?? (
                        <span className="text-warning-900">N/A</span>
                      )}
                    </div>
                  </td>

                  <td className="max-w-[180px] align-top">
                    <div className="h-[40px] w-full truncate break-words rounded-lg border border-solid border-neutral-200 bg-neutral-50 px-3 py-2">
                      {file.sampleEntries[2][index] ?? (
                        <span className="text-warning-900">N/A</span>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReviewAndEdit;
